<template>
  <div class="notifications-item-chat-response">
    <div class="notifications-item-chat-response__header">
      <div class="notifications-item-chat-response__profile">
        <ForumResponseAvatar
          :response="response"
          :chat-id="chatId"
          small
          class="notifications-item-chat-response__avatar"
        />
        <ForumResponseProfile
          class="notifications-item-chat-response__name"
          small
          hide-notice
          :response="response"
        />
      </div>
      <LLTimestamp class="notifications-item-chat-response__timestamp" :timestamp="notification.createdAt">
        <template #default="data">
          {{ data.time }}
        </template>
      </LLTimestamp>
    </div>
    <LLFileSlider
      v-if="response.files.length"
      class="notifications-item-chat-response__files"
      :owner="owner"
      :files="response.files"
      :z-index="10001"
      small
    ></LLFileSlider>
    <ForumResponseBodyText
      class="notifications-item-chat-response__body"
      :response="response"
      small
      truncate
      lines="2"
    />
  </div>
</template>

<script>
import { NotificationModel } from '@/models/notification'
import ForumResponseAvatar from '@/components/pages/forum/response/ForumResponseAvatar.vue'
import ForumResponseProfile from '@/components/pages/forum/response/ForumResponseProfile.vue'
import ForumResponseBodyText from '@/components/pages/forum/response/body/ForumResponseBodyText.vue'
import LLTimestamp from '@/components/common/LLTimestamp.vue'
import LLFileSlider from '@/components/common/LLFileSlider.vue'
import { ownerFromForumModel } from '@/utils/fileOwner'

export default {
  name: 'NotificationsItemChatResponse',
  components: {
    LLFileSlider,
    LLTimestamp,
    ForumResponseBodyText,
    ForumResponseProfile,
    ForumResponseAvatar
  },
  props: {
    notification: { type: NotificationModel, required: true }
  },
  computed: {
    response() {
      return this.notification.payload.chatMention.response
    },
    chatId() {
      return this.notification.payload.chatMention?.chat?.id ?? null
    },
    owner() {
      return ownerFromForumModel({
        model: this.response,
        currentUserId: this.$store.getters['user/user']?.id
      })
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-item-chat-response {
  &__timestamp {
    @apply text-xs flex-shrink-0;
  }
  &__header {
    @apply flex items-center justify-between w-full;
    min-width: 0;
  }
  &__avatar {
    @apply mr-2;
  }
  &__profile {
    @apply flex items-center min-w-0 mr-2;
  }
  &__name {
    @apply min-w-0;
    ::v-deep .ForumResponseProfile__moderator-name {
      @apply text-primary-01;
    }
  }
  &__files {
    @apply mt-2;
  }
  &__body {
    @apply mt-2 text-body-03;
  }
}
</style>
